import { Maybe } from '@crocodille/common';
import NextImage, { ImageProps as NextImageProps } from 'next/legacy/image';
import React from 'react';

import placeholder from '../../../../public/placeholder.png';

export interface ImageProps extends Omit<NextImageProps, 'src'> {
  readonly src?: Maybe<NextImageProps['src']>;
  readonly fallbackSrc?: NextImageProps['src'];
}

const Image: React.FC<React.PropsWithChildren<ImageProps>> = ({
  fallbackSrc = placeholder,
  src,
  ...props
}: ImageProps) => {
  return <NextImage src={src ?? fallbackSrc} {...props} />;
};

export default Image;
